import React from "react";
import ContributorPage from "../../../components/_shared/ContributorPage";
import { ContributorType } from "../../../shared/constant";

const Lyricists = () => {
  return <ContributorPage contributorType={ContributorType.LYRICIST} />;
};

export default Lyricists;
